var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BoxWrap", { attrs: { title: _vm.$t("sfe.route.taskassignment") } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "FPermission",
                rawName: "v-FPermission",
                value: { pageName: _vm.pageName, list: ["LIST"] },
                expression: "{ pageName, list: ['LIST'] }",
              },
            ],
            staticClass: "action-container",
          },
          [
            _c(
              "el-form",
              {
                staticClass: "searchForm",
                attrs: {
                  model: _vm.searchVal,
                  size: "small",
                  inline: "",
                  "label-position": "top",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("sfe.taskassignment.input.taskDescription"),
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          multiple: "",
                          placeholder: _vm.$t(
                            "sfe.taskassignment.input.optionPlaceholder"
                          ),
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchVal.taskDescriptionList,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchVal, "taskDescriptionList", $$v)
                          },
                          expression: "searchVal.taskDescriptionList",
                        },
                      },
                      _vm._l(_vm.taskDescriptionList, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item, value: item },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("sfe.taskassignment.input.rsmEmpNo"),
                    },
                  },
                  [
                    _c("FormInput", {
                      attrs: { val: _vm.searchVal.rsmEmpNo },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.searchVal, "rsmEmpNo", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("sfe.taskassignment.input.rsmEmpName"),
                    },
                  },
                  [
                    _c("FormInput", {
                      attrs: { val: _vm.searchVal.rsmEmpName },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.searchVal, "rsmEmpName", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("sfe.taskassignment.input.asmEmpNo"),
                    },
                  },
                  [
                    _c("FormInput", {
                      attrs: { val: _vm.searchVal.asmEmpNo },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.searchVal, "asmEmpNo", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("sfe.taskassignment.input.asmEmpName"),
                    },
                  },
                  [
                    _c("FormInput", {
                      attrs: { val: _vm.searchVal.asmEmpName },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.searchVal, "asmEmpName", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("sfe.taskassignment.input.srEmpNo"),
                    },
                  },
                  [
                    _c("FormInput", {
                      attrs: { val: _vm.searchVal.srEmpNo },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.searchVal, "srEmpNo", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("sfe.taskassignment.input.srEmpName"),
                    },
                  },
                  [
                    _c("FormInput", {
                      attrs: { val: _vm.searchVal.srEmpName },
                      on: {
                        "update:val": function ($event) {
                          return _vm.$set(_vm.searchVal, "srEmpName", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("sfe.taskassignment.input.deadlineTime"),
                    },
                  },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        clearable: "",
                        type: "date",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: _vm.$t("common.selectDatetime"),
                        "picker-options": _vm.startStartDatetimeOptions,
                      },
                      model: {
                        value: _vm.searchVal.deadlineTimeStart,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchVal, "deadlineTimeStart", $$v)
                        },
                        expression: "searchVal.deadlineTimeStart",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "picker-line" }, [_vm._v("-")]),
                    _vm._v(" "),
                    _c("el-date-picker", {
                      attrs: {
                        clearable: "",
                        type: "date",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        placeholder: _vm.$t("common.selectDatetime"),
                        "picker-options": _vm.startEndDatetimeOptions,
                      },
                      model: {
                        value: _vm.searchVal.deadlineTimeEnd,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchVal, "deadlineTimeEnd", $$v)
                        },
                        expression: "searchVal.deadlineTimeEnd",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { slot: "footer-right" }, slot: "footer-right" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "FPermission",
                    rawName: "v-FPermission",
                    value: { pageName: _vm.pageName, list: ["LIST"] },
                    expression: "{ pageName, list: ['LIST'] }",
                  },
                ],
                attrs: { size: "small", icon: "el-icon-refresh" },
                on: { click: _vm.resetData },
              },
              [_vm._v(_vm._s(_vm.$t("common.reset")) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "FPermission",
                    rawName: "v-FPermission",
                    value: { pageName: _vm.pageName, list: ["LIST"] },
                    expression: "{ pageName, list: ['LIST'] }",
                  },
                ],
                staticClass: "t-search-btn",
                attrs: { size: "small", icon: "el-icon-search" },
                on: { click: _vm.searchData },
              },
              [_vm._v(_vm._s(_vm.$t("common.search")) + "\n      ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("common.list") },
        },
        [
          _c("div", { attrs: { slot: "header-right" }, slot: "header-right" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT"] },
                        expression: "{ pageName, list: ['EXPORT'] }",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.downloadExcel },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.export")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("ImportExcel", {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["IMPORT"] },
                      expression: "{pageName, list: ['IMPORT']}",
                    },
                  ],
                  attrs: {
                    "is-loading": _vm.isLoading,
                    "opt-config": _vm.optConfig,
                  },
                  on: {
                    "update:isLoading": function ($event) {
                      _vm.isLoading = $event
                    },
                    "update:is-loading": function ($event) {
                      _vm.isLoading = $event
                    },
                    refresh: _vm.searchData,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "taskDescription",
                  label: _vm.$t("sfe.taskassignment.table.taskDescription"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "allocatedType",
                  label: _vm.$t("sfe.taskassignment.table.allocatedType"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "deadlineTimeFormatted",
                  label: _vm.$t(
                    "sfe.taskassignment.table.deadlineTimeFormatted"
                  ),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rsmEmpNo",
                  label: _vm.$t("sfe.taskassignment.table.rsmEmpNo"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rsmEmpName",
                  label: _vm.$t("sfe.taskassignment.table.rsmEmpName"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "asmEmpNo",
                  label: _vm.$t("sfe.taskassignment.table.asmEmpNo"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "asmEmpName",
                  label: _vm.$t("sfe.taskassignment.table.asmEmpName"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "srEmpNo",
                  label: _vm.$t("sfe.taskassignment.table.srEmpNo"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "srEmpName",
                  label: _vm.$t("sfe.taskassignment.table.srEmpName"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlRtmCategory",
                  label: _vm.$t("sfe.taskassignment.table.rtlRtmCategory"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "retailerType",
                  label: _vm.$t("sfe.taskassignment.table.retailerType"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "spSapId",
                  label: _vm.$t("sfe.taskassignment.table.spSapId"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "spFullName",
                  label: _vm.$t("sfe.taskassignment.table.spFullName"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlRegion",
                  label: _vm.$t("sfe.taskassignment.table.rtlRegion"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlCity",
                  label: _vm.$t("sfe.taskassignment.table.rtlCity"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlSapId",
                  label: _vm.$t("sfe.taskassignment.table.rtlSapId"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtlFullName",
                  label: _vm.$t("sfe.taskassignment.table.rtlFullName"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: _vm.$t("sfe.taskassignment.table.remark"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }